import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const SignupStart: React.FC = () => {
  const navigate = useNavigate();

  const handleUserTypeSelect = (userType: string) => {
    navigate('/signup/verify', { state: { user_type: userType } });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 bg-gray-50 py-12 mt-20">
        <div className="max-w-5xl mx-auto px-4">
        {/* Contents Head */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <h3 className="text-3xl font-bold text-gray-900">통합회원가입</h3>
            {/* 타이틀 메뉴 */}
            <div className="flex gap-4 text-sm">
              <Link to="/login" className="text-gray-600 hover:text-[#48c9a6]">로그인</Link>
              <Link to="/signup" className="text-[#48c9a6] font-medium">통합회원가입</Link>
            </div>
          </div>
          <div className="h-1 bg-[#48c9a6] w-20 mt-4"></div>
        </div>

        {/* Selection Box */}
        <div className="w-5/6 mx-auto p-12 border-2 border-[#48c9a6] bg-white">
          {/* Title */}
          <h2 className="flex items-center gap-2 mb-8 text-xl font-bold text-gray-900">
            <svg className="w-6 h-6 text-[#48c9a6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
            회원유형 선택
          </h2>

          {/* Options */}
          <div className="flex gap-6 flex-wrap">
            {/* 일반회원 */}
            <button
              onClick={() => handleUserTypeSelect('adult')}
              className="flex-1 border border-[#ddd] p-8 text-center transition-all duration-200 hover:border-[#48c9a6] hover:bg-[#48c9a6]/5"
            >
              <div className="w-20 h-20 mx-auto mb-4 bg-[#48c9a6]/10 rounded-full flex items-center justify-center">
                <svg className="w-10 h-10 text-[#48c9a6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <strong className="block mt-4 text-lg font-semibold text-gray-900">일반회원</strong>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">만 14세 이상 내국인</p>
            </button>

            {/* 학부모 회원 */}
            <button
              onClick={() => handleUserTypeSelect('guardian')}
              className="flex-1 border border-[#ddd] p-8 text-center transition-all duration-200 hover:border-[#48c9a6] hover:bg-[#48c9a6]/5"
            >
              <div className="w-20 h-20 mx-auto mb-4 bg-[#48c9a6]/10 rounded-full flex items-center justify-center">
                <svg className="w-10 h-10 text-[#48c9a6]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <strong className="block mt-4 text-lg font-semibold text-gray-900">학부모 회원</strong>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                만 14세 미만 자녀 교육 신청<br />
                보호자의 본인인증이 필요합니다
              </p>
            </button>
          </div>
        </div>

        {/* 안내 문구 */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            이미 계정이 있으신가요? {' '}
            <Link to="/login" className="text-[#48c9a6] hover:text-[#3ab89a] font-medium">
              로그인
            </Link>
          </p>
        </div>
      </div>
      </div>

      <Footer />
    </div>
  );
};

export default SignupStart;
